
const jvFormAllow = ['number']

const obj = {
    jvFormAllow
}

module.exports = obj
